import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import {useQueryParams} from "../hooks/useQueryParams";
import {Input, Modal} from "antd";

export type WechatScanLoginFormPropsType = {
    url: string
}

export function withWechatScanLoginForm(WrappedComponent: React.FC<WechatScanLoginFormPropsType>) {
    return (props: any) => {
        const queryParams = useQueryParams();
        const params: any = {
            ...queryParams
        }
        delete params['locale']
        const [url, setUrl] = useState<string>();
        useEffect(() => {
            setUrl("//act.longtugame.com/lthd/wx_login?logincallback=" + encodeURIComponent(process.env.REACT_APP_ACCOUNT_URL + 'api/oauth2/wechat/scanCodeLogin.htm') + "&actiontype=1&hostname=" + encodeURIComponent(process.env.REACT_APP_BAS_HOST + '/#') + '&oauth2=' + encodeURIComponent(JSON.stringify(params)))
        }, [queryParams])
        return (
            <>
                <WrappedComponent {...props}
                                  url={url}
                />
            </>
        )

    }
}
